import { Divider, Paper, Stack } from "@mui/material";
import React from "react";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import { ItemCarrinho } from "../../CatalogoPage";
import ItemCarrinhoCardComponent from "./ItemCarrinhoCardComponent";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";

interface CarrinhoPaperComponent {
    onChangeOpenCarrinho: () => void;
    component: any;
    buttonLabel: string;
    onClickFooter: () => void;
    disabled: boolean;
}

const CarrinhoPaperComponent = (props: CarrinhoPaperComponent) => {
    return <Paper
        elevation={10}
        sx={{
            position: 'fixed',
            bottom: {
                xs: 67,
                sm: 80
            },
            right: 20,
            width: '30vw',
            minWidth: '330px',
            maxWidth: "330px",
            maxHeight: '85vh',
            display: {
                xs: "flex",
                sm: 'flex'
            },
            flexDirection: 'column',
            borderRadius: 3,
            overflow: 'hidden',
            zIndex: 1200,
            border: '1px solid',
            borderColor: 'divider',
        }}
    >
        {/* Cabeçalho Fixo do Carrinho */}
        <BoxComponent
            component="header"
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "0.8px solid var(--color-grey-91, #E5E7EB)",
                backgroundColor: "#F9FAFBF9FAFB"
            }}>
            <TypographyComponent
                variant="h2" fontWeight="bold"
                sx={{
                    fontFamily: '"Font 2", sans-serif',
                    fontWeight: 700,
                    fontSize: '24px',
                    lineHeight: '32px',
                    letterSpacing: '0%',
                    color: '#101828',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle'
                }}
            >
                Carrinho
            </TypographyComponent>
            <ButtonComponent id="fechar-paper" onClick={props.onChangeOpenCarrinho} sx={{
                color: '#101828',
                minWidth: 40, maxWidth: 40,
                height: 40, maxHeight: 40
            }}>
                X
            </ButtonComponent>
        </BoxComponent>

        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                //p: 2,
                backgroundColor: "#F9FAFB",
                //background: "red",
                width: "100%",
                overflow: "auto"
            }}>
            {props.component}
        </BoxComponent>

        <Divider />

        {/* Rodapé Fixo do Carrinho */}
        <BoxComponent component="footer" sx={{ p: 2, bgcolor: 'background.paper' }}>
            {/* SELECT - Forma de Pagamento */}
            {/* <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Forma de pagamento</InputLabel>
        <Select
          value={formaSelecionada}
          label="Forma de pagamento"
          onChange={(e) => onChangeFormaPagamento(e.target.value)}
        >
          {formasPagamento.map((fp: any) => (
            <MenuItem key={fp.id} value={fp.id}>
              {fp.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}

            {/* SELECT - Tipo do Pedido */}
            {/* <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Tipo do pedido</InputLabel>
        <Select
          value={tipoPedido}
          label="Tipo do pedido"
          onChange={(e) => onChangeTipoPedido(e.target.value)}
        >
          <MenuItem value="MESA">Mesa</MenuItem>
          <MenuItem value="DELIVERY">Delivery</MenuItem>
          <MenuItem value="BALCAO">Balcão</MenuItem>
        </Select>
      </FormControl>
      */}
            <ButtonComponent
                id="botao-envio-pedido"
                type="button"
                variant="contained"
                //disabled={props.itens.length === 0}
                sx={{
                    width: "100%",
                    backgroundColor: "#E7000B",
                    py: 1,
                    borderRadius: "10.4px",
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0%',
                    textAlign: 'center',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    textTransform: "inherit",
                    color: "#FFFFFF"
                }}
                onClick={props.onClickFooter}
                disabled={props.disabled}
            >
                {props.buttonLabel}
            </ButtonComponent>
        </BoxComponent>
    </Paper>
}

export default CarrinhoPaperComponent;